import { graphql } from 'gatsby'
import React from 'react'
import CompaniesData from '~/data/sidebar/companies.json'

const Companies = ({ block }) => {
  const { type } = block
  const blockType = type ? `block__companies--${type}` : ''

  if (!block.companies_list || !block.companies_list.length) {
    block.companies_list = CompaniesData.companies.map((item) => {
      // @ts-ignore
      item.company_class = item.name.replace(/\s/g, '').toLowerCase()
      return item
    })
  }

  return (
    <section
      className={`block ${blockType} ${block._template} ${block.css_class_name}`}
    >
      <div className="container">
        {block.title && (
          <h2 dangerouslySetInnerHTML={{ __html: block.title }}></h2>
        )}

        <ul>
          {block.companies_list.map((company, index) => {
            return (
              <li key={index} className={type === 'compact' ? 'col-2' : ''}>
                <img
                  className={company.company_class}
                  src={company.logo}
                  alt={`${company.name} Logo`}
                  title={`${company.name} Logo`}
                  loading="lazy"
                />
              </li>
            )
          })}
        </ul>

        {block.text && <p dangerouslySetInnerHTML={{ __html: block.text }} />}
      </div>
    </section>
  )
}
export const companyFragment = graphql`
  fragment CompanyFragment on Company {
    name
    logo
    company_class
  }
`

export default Companies
